import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import LayoutSizes from '../enums/layout/layoutSizes';
import LayoutTypes from '../enums/layout/layoutTypes';
import useWindowResize from '../hooks/useWindowResize';
import {setLayout} from '../state/ducks/global';
import {makeSelectLayoutType} from '../state/selectors/global';

const useLayoutChange = () => {
    const layoutType = useSelector(makeSelectLayoutType());
    const dispatch = useDispatch();
    const getSize = () => ({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [windowSize, setWindowSize] = useState(getSize());
    const onResize = () => setWindowSize(getSize());
    const currentLayout = getLayout(windowSize.width);

    useWindowResize(onResize);
    useEffect(() => {
        if (layoutType !== currentLayout) {
            dispatch(setLayout(currentLayout));
        }
    }, [layoutType, currentLayout]);
};

const getLayout = (deviceWidth) => {
    if (deviceWidth <= LayoutSizes.MOBILE) {
        return LayoutTypes.MOBILE;
    } else if (deviceWidth >= LayoutSizes.DESKTOP) {
        return LayoutTypes.DESKTOP;
    } else {
        return LayoutTypes.TABLET;
    }
};

export default useLayoutChange;
